<template><!-- 商品頁保險小學堂 -->
    <div class="school">
        <h2 class="title center">保險小學堂</h2>
        <div class="container">
            <div class="schoolPic"><img src="../../assets/book.svg" alt=""><p>延伸閱讀</p></div>
            <div class="line"></div>
            <div class="schoolList">
                <ul>
                    <li><a class="school_accu0" href="https://www.tmnewa.com.tw/b2c_v2/contents/rent-travel.html" target="_blank">租借車不傷情，保障荷包安心遊</a></li>
                    <li><a class="school_accu1" href="https://yahoo.ebo.tmnewa.com.tw/tmnewa/portal/video_con?uid=481" target="_blank">環島達人公開機車環島重點！</a></li>
                    <li><a class="school_accu2" href="https://yahoo.ebo.tmnewa.com.tw/tmnewa/portal/video_con?uid=470" target="_blank">國內旅遊遇上意外怎麼辦?</a></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
.school{
  padding:50px 0;
  background:$lightBlue;
  font-weight:500;
  .container{
    background:$mainColor;
    border: 2px solid #EBECED;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: $radius;
    display:flex;
    padding:35px 0;
    box-sizing:border-box;
    width:900px;
    color:$textColor;
      margin:50px auto 20px;
    @media screen and (max-width: $padLandscape) {
      width:90%;
      margin:50px auto;
    }
    @media screen and (max-width: $padMini) {
      display:block;
    }
    .schoolPic{
      padding:0 100px;
      text-align: center;
      letter-spacing: 5px;
      font-size: 24px;
      @media screen and (max-width: $padLandscape) {
        font-size:20px;

      }
      @media screen and (max-width: $pad) {
        padding:0 50px;
      }
      @media screen and (max-width: $padMini) {
        display: flex;
        align-items:center;
        padding:0 20px;
        p{margin:0;margin-left:10px;}
        img{width:105px;}
      }
      p{margin-top:10px;}
    }
    .line{
      border-right:1px solid $gray;
      position:relative;
      margin:0;
      &::before{
        content:"";
        width:5px;
        height:5px;
        border-radius:5px;
        background:$gray;
        position:absolute;
        top:-2.95px;
        right:-3.95px;
      }
      &::after{
        content:"";
        width:5px;
        height:5px;
        border-radius:5px;
        background:$gray;
        position:absolute;
        bottom:-2.95px;
        right:-3.95px;
      }

      @media screen and (max-width: $padMini) {
        width:90%;
        margin:10px auto;
        border: 0;
        height:1px ;
        background:$gray;
        &::before{
          left:-2px;
          top:1px;
        }
        &::after{
          right:-2px;
          top:1px;
        }
      }
    }
    .schoolList{
      padding:0 20px;
      line-height:60px;
      box-sizing: border-box;
      padding:10px 50px;
      @media screen and (max-width: $padMini) {
        padding: 10px 15px 10px 40px;
      }
      ul {
        list-style-type: disc;
        list-style-position: outside;
      }
      li{
        &::marker{
          font-size: 1.2em;
          display: inline-block;
          margin-right:10px;
          vertical-align: middle;
        }
        a{text-decoration: underline; color:$textColor;}
        @media screen and (max-width: $pad) {
          margin:15px 0;
          line-height:25px;
        }
      }
    }
  }
}
</style>